export default __webpack_public_path__ + "static/media/pic5.888f7fbc.jpg";